import React, { Component } from 'react';
import { Layout, Menu, Breadcrumb } from 'antd';
import { DatabaseOutlined, PieChartOutlined } from '@ant-design/icons';
import logo from '../assets/infocop.png'
import { getUser, isLoggedIn, LogoutUser } from "../helpers/authentication";
import { Redirect, useHistory } from "react-router-dom";

const { SubMenu } = Menu;
const { Header, Content, Sider } = Layout;

export function MainLayout(props) {
    const sVersion = '1.1.7'
    let history = useHistory();
    const [user, SetUser] = React.useState(getUser())
    return (
        isLoggedIn() ?
            <Layout>
                <Header className="header">
                    <div className="logo"> <img src={logo} alt={""} style={{ width: "200px", marginBottom: "10px" }} /> </div>
                </Header>
                <Layout>
                    <Sider width={250} className="site-layout-background">
                        <Menu
                            mode="inline"
                            defaultSelectedKeys={['Dashboard']}
                            defaultOpenKeys={['sub1']}
                            style={{ height: '100%', borderRight: 0 }}
                        >
                            <div style={{ margin: '20px', color: 'slategray', fontSize: 13 }}>{user?.firstname} {user?.lastname}</div><hr />
                            <Menu.Item key="Dashboard" onClick={() => { history.push('/') }}>Dashboard</Menu.Item>
                            {(user?.authlvl === 'Z' || user?.authlvl === 'H') && user?.dept === 'CENTRAL' && <Menu.Item key="Admin" icon={<DatabaseOutlined />} onClick={() => { history.push('/icadmin') }}>Admin</Menu.Item>}
                            <SubMenu key="sub2" icon={<PieChartOutlined />} title="Reports">
                                <Menu.Item key="Activity Hit" onClick={() => { history.push('/report/activity-hit') }}>Activity Hit</Menu.Item>
                                <Menu.Item key="Chat Lookup" onClick={() => { history.push('/report/chat-lookup') }}>Chat Lookup</Menu.Item>
                                <Menu.Item key="Device Lookup" onClick={() => { history.push('/report/device-lookup') }}>Device Lookup</Menu.Item>
                                <Menu.Item key="Executive Stats" onClick={() => { history.push('/report/executive-stats-department') }}>Executive Stats</Menu.Item>
                                <Menu.Item key="Employee Executive Stats" onClick={() => { history.push('/report/executive-stats-employee') }}>Employee Executive Stats</Menu.Item>
                                <Menu.Item key="Employee Checks" onClick={() => { history.push('/report/employee-checks') }}>Employee Checks</Menu.Item>
                                <Menu.Item key="Employee Detail Checks" onClick={() => { history.push('/report/employee-detail-checks') }}>Employee Detail Checks</Menu.Item>
                                <Menu.Item key="Employee Hit" onClick={() => { history.push('/report/employee-hit') }}>Employee Hit</Menu.Item>

                                <Menu.Item key="Stop Log" onClick={() => { history.push('/report/stoplog') }}>Stop Log</Menu.Item>
                                <Menu.Item key="Stop Log DDACTS" onClick={() => { history.push('/report/stoplog-ddacts') }}>Stop Log DDACTS</Menu.Item>
                                <Menu.Item key="Stop Log by Officer" onClick={() => { history.push('/report/stoplog-by-officer') }}>Stop Log by Officer</Menu.Item>
                                <Menu.Item key="Warning Report" onClick={() => { history.push('/report/warning') }}>Warning Report</Menu.Item>
                            </SubMenu>
                            <Menu.Item key="Log Off" onClick={() => { LogoutUser(); history.push('/login') }}>Log Off</Menu.Item>
                            <hr />
                            <div style={{ margin: '20px', color: 'slategray', fontSize: 10 }}>SITE VERSION {sVersion}</div>
                        </Menu>
                    </Sider>
                    <Layout style={{ padding: '0 24px 24px', backgroundColor: "white" }} >
                        {props.children}
                    </Layout>
                </Layout>
            </Layout> : <Redirect to={"/login"} />
    );
}
